export const isDev = () =>
  !process.env.NODE_ENV ||
  process.env.NODE_ENV === 'development' ||
  process.env.NODE_ENV === 'test'

export const isTesting = () =>
  process.env.REACT_APP_DEPLOYMENT_ENV === 'testing'

export const isStaging = () =>
  process.env.REACT_APP_DEPLOYMENT_ENV === 'staging'

export const isProduction = () =>
  process.env.REACT_APP_DEPLOYMENT_ENV === 'prod'

export const isEuProd = () => process.env.REACT_APP_DEPLOYMENT_ENV === 'eu-prod'
